// extracted by mini-css-extract-plugin
export default {"summaryCard":"SummarySection_summaryCard__AEqal","title":"SummarySection_title__-b5-B"};